import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";
import heroImg from "@/assets/towns/lone-tree.jpg";

const CONFIG: SpokePageConfig = {
  slug: "web-design-seo-lone-tree",
  metaTitle: "Lone Tree Web Design & SEO | Local Google Maps Help",
  metaDescription: "Web design and SEO for Lone Tree, CO businesses. Websites from $1,850, local SEO and Google Maps from $950/month. Based in Colorado Springs, month-to-month.",
  breadcrumbs: [{ label: "Home", to: "/" }, { label: "Colorado Springs Headquarters", to: "/colorado-springs-headquarters" }],
  currentLabel: "Lone Tree",
  eyebrow: "Lone Tree, CO · Douglas County",
  h1: (
    <>
      Web Design &amp; SEO in <span className="text-brand-gold">Lone Tree, Colorado</span>
    </>
  ),
  heroDescription: "Help Lone Tree customers find you first on Google, Google Maps and AI search.",
  intro: "We build websites and local SEO for businesses in Lone Tree, RidgeGate and the south Denver metro. Chris Heidlebaugh works from our Woodmen Rd office in Colorado Springs, within our 60-mile service area, with 27 years of experience helping local companies get found.",
  definition: { term: "Lone Tree local SEO", body: "Making your business show up when people in and around Lone Tree search Google, Google Maps and AI tools for what you offer." },
  whatWeDo: [
    { title: "Lone Tree website", body: "A fast site with pages for your services and the Lone Tree area." },
    { title: "Google Maps", body: "A complete profile with photos, services and steady reviews." },
    { title: "Nearby towns", body: "Pages for Highlands Ranch, Centennial and Castle Pines too." },
    { title: "AI search", body: "Plain answers ChatGPT and Google can repeat." },
    { title: "Clear pricing", body: "Websites from $1,850. Marketing from $950/mo." },
    { title: "Free audit", body: "See what is holding your Lone Tree rankings back." },
  ],
  whyThisMarket: [
    { heading: "Local searches", body: "Busy medical, office and retail areas where many businesses compete for the same searches." },
    { heading: "Douglas County", body: "We know Douglas County and serve it from Colorado Springs." },
    { heading: "No long contracts", body: "Monthly marketing is month-to-month." },
  ],
  relatedLinks: [
    { to: "/marketing-lone-tree", label: "Marketing in Lone Tree: social, ads, reviews & Maps" },
    { to: "/colorado-springs-headquarters", label: "Our 60-mile service area" },
    { to: "/colorado-springs-office-woodmen-rd", label: "Our Woodmen Rd office" },
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
  ],
  faqs: [
    { q: "Do you work with businesses in Lone Tree?", a: "Yes. Lone Tree is in our 60-mile service area around Colorado Springs. We can meet in person or by video." },
    { q: "How much does a website cost?", a: "Websites are $1,850, $2,750 or $5,950 one-time with one year of hosting and SSL. Monthly marketing is $950, $1,650 or $2,750 per month." },
    { q: "How fast can my website be ready?", a: "Most websites are ready in under 7 business days." },
  ],
  serviceName: "Web Design and SEO in Lone Tree, CO",
  serviceDescription: "Web design, local SEO and Google Maps help for Lone Tree, Colorado businesses.",
  heroImage: { src: heroImg, alt: "Lone Tree, Colorado shopping district with Front Range views", geo: { lat: 39.5364, lng: -104.8847, city: "Lone Tree, CO" } },
  areaServed: "Lone Tree, CO",
};

export const Route = createFileRoute("/web-design-seo-lone-tree")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
